export default "__VITE_ASSET__19WRvkLM__"